import { render, staticRenderFns } from "./ModulePage.vue?vue&type=template&id=695c815a"
import script from "./ModulePage.vue?vue&type=script&lang=js"
export * from "./ModulePage.vue?vue&type=script&lang=js"
import style0 from "./ModulePage.vue?vue&type=style&index=0&id=695c815a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports